"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class SourceCode {
    constructor(sourceCode, sourceMap) {
        this.sourceCode = sourceCode;
        this.sourceMap = sourceMap;
    }
    getSourceCode() {
        return this.sourceCode;
    }
    getSourceMap() {
        return this.sourceMap;
    }
    toString() {
        return this.sourceCode;
    }
}
exports.SourceCode = SourceCode;
